import { connect } from "react-redux";

import { AdditionalSecurityComponent } from "./AdditionalSecurity";

export const AdditionalSecurity = connect()(AdditionalSecurityComponent);
